// extracted by mini-css-extract-plugin
export var baseButton = "_vg-0";
export var controlsArrowKeys = "_vg-1";
export var controlsResetButton = "_vg-2";
export var lightGameButton = "_vg-4 _vg-0";
export var playAgainButton = "_vg-5 _vg-0";
export var startGameButton = "_vg-3 _vg-0";